import React from "react";
import { Grid } from "@mui/material";
import SkeletonCard from "./SkeletonCard";

const SkeletonGrid = ({ count = 12 }) => (
  <Grid container spacing={3} alignItems="flex-start" sx={{ p: 2, justifyContent: "center" }}>
    {Array.from({ length: count }).map((_, i) => (
      <Grid item xs={12} sm={6} md={4} lg={3} key={i}>
        <SkeletonCard />
      </Grid>
    ))}
  </Grid>
);

export default SkeletonGrid;
